import "./index.scss";

import { BaseProps } from "@types";
import classNames from "classnames";
import React from "react";

export default function Container({ className, children }: BaseProps) {
  return <div className={classNames(className, "container")}>{children}</div>;
}
